import { useMemo } from 'react';
import Helmet from '../lib/Helmet';
import { usedSources } from '../data/guideInverter';
import { CONSULT_SERVICES } from '../data/consultation';
import { VRVH_SEO, VRVH_UPDATED, VRVH_SOURCES, VRV_HOME_SIZES, VRV_S_SIZES, VRV_ALPHA_RANGE, vrvHomeContent } from '../data/guideVrvHome';
import { GuideHeader, GuideBody } from '../components/guide/GuideParts';
import VrvPick from '../components/guide/VrvPick';

// Route: /blog/vrv-system-for-home — AC guide 10 (5 Nov 2026), in the new
// layout. Every word comes from vrvHomeContent() in data/guideVrvHome.js
// (Saheb's answers of 5 Nov 2026 and Daikin's VRV pages), which
// scripts/guide-pages.js reads too.

const priceOf = (id) => (CONSULT_SERVICES.find((s) => s.id === id) || {}).price;

export default function VrvHomeGuide() {
  const { c, S } = useMemo(() => {
    const content = vrvHomeContent({ call: priceOf('call'), visit: priceOf('visit') });
    return { c: content, S: usedSources(VRVH_SOURCES, content) };
  }, []);

  return (
    <>
      <Helmet>
        <title>{VRVH_SEO.title}</title>
        <meta name="description" content={VRVH_SEO.meta} />
        <meta property="og:title" content={VRVH_SEO.title} />
        <meta property="og:description" content={VRVH_SEO.meta} />
      </Helmet>
      <main className="bg-white pb-16 pt-16 lg:pt-20">
        <article className="mx-auto max-w-[760px] px-4 text-base leading-relaxed text-gray-900">
          <GuideHeader seo={VRVH_SEO} updated={VRVH_UPDATED} crumb={VRVH_SEO.crumb} />
          <GuideBody c={c} sources={S} current="vrv-system-for-home" ctaSource="guide_vrv_home"
            ctaTitle="Planning VRV for your home?"
            watch={<VrvPick watch={c.watch} sources={S}
              homeMaxHp={VRV_HOME_SIZES[VRV_HOME_SIZES.length - 1].hp}
              sMaxHp={VRV_S_SIZES[VRV_S_SIZES.length - 1].hp}
              alphaMaxHp={VRV_ALPHA_RANGE.maxHp} />} />
        </article>
      </main>
    </>
  );
}
